import { useUnlinkConversationFromOpportunityMutation } from "@qw/graphql";
import { Button, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";
import { type FC, useCallback } from "react";

export const UnlinkOpportunityButton: FC<{
  conversationId: string;
  opportunityId: string;
}> = ({ conversationId, opportunityId }) => {
  const [unlinkConversationFromOpportunity] = useUnlinkConversationFromOpportunityMutation({
    refetchQueries: ["InboxConversation"],
  });

  const handleClick = useCallback(async () => {
    await unlinkConversationFromOpportunity({
      variables: { input: { conversationId, opportunityId } },
    });
  }, [conversationId, opportunityId, unlinkConversationFromOpportunity]);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button variant="ghost" size="xs" display="icon" className="group/button" onClick={handleClick}>
          <Icon icon="link" className="group-hover/button:hidden" />
          <Icon icon="link_off" className="hidden group-hover/button:inline" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Unlink Marketing Plan</TooltipContent>
    </Tooltip>
  );
};
